import Holiday from '@/classes/Holiday';
class HolidayList {
    holidays = [];
    constructor(holidayJson) {
        if (holidayJson !== null) {
            this.holidays = [];
            holidayJson.forEach((holiday) => {
                const tempHoliday = new Holiday(holiday);
                this.holidays.push(tempHoliday);
            });
        }
    }
    getHolidayForDate(date) {
        const holidayRet = this.holidays.find((holiday) => {
            return window.dateHandler.formatDateNoTime(holiday.date) === window.dateHandler.formatDateNoTime(date);
        });
        return holidayRet;
    }
    isRedDay(date) {
        const holiday = this.getHolidayForDate(date);
        if (holiday !== undefined) {
            return true;
        }
        else if (window.dateHandler.isDateWeekend(date)) {
            return true;
        }
        else {
            return false;
        }
    }
}
export default HolidayList;
